import { FC } from 'react';
import { Button, Icon } from '../../../../../../src/shared/ui';
import { IconMap } from '../../../../../..//src/shared/sprite';
import { useDispatch, useSelector } from 'react-redux';
import { callModel } from '../../../../../features/call';

export const NoCallsFoundScreen: FC = () => {
  const dispatch = useDispatch();

  const callListOptions = useSelector(
    callModel.selectors.selectCallListOptions
  );

  const clearSearchQuery = () => {
    dispatch(
      callModel.actions.setListOptions({
        ...callListOptions,
        search: '',
      })
    );
    dispatch(callModel.actions.loadCallsForEditor());
  };

  const isClearSearchButton = Boolean(callListOptions.search);

  return (
    <div className="flex flex-col items-center justify-center flex-grow w-full h-full gap-2 overflow-hidden">
      <div className="flex items-center justify-center w-12 h-12 mb-4 text-gray-700 border border-gray-200 rounded-lg shadow-xs">
        <Icon glyph={IconMap.SearchMd} width={24} />
      </div>
      <p className="mb-1 font-semibold text-gray-900 text-md">
        No call recordings found
      </p>
      <p className="text-gray-600 text-sm font-normal max-w-[352px] text-center mb-6">
        {isClearSearchButton
          ? 'We cannot find recordings you need, please try to adjust your search criteria. '
          : 'We cannot find recording you need, but you can always create your own.'}
      </p>
      {isClearSearchButton && (
        <Button variant="text" color="secondary" onClick={clearSearchQuery}>
          Clear search
        </Button>
      )}
    </div>
  );
};
